import React, { useContext } from 'react';

import { ADFRenderer } from '@confluence/adf-renderer/entry-points/ADFRenderer.ts';
import type { ADFRendererProps } from '@confluence/adf-renderer/entry-points/ADFRendererComponent.ts';

import { NestedLcmHierarchyContext } from './NestedLcmHierarchyContext.ts';
import { useNestedLcmProviderFactory } from './useNestedLcmProviderFactory.ts';

/** Nested content inherits its enclosing renderer's decision instead of accepting an override. */
type NestedLcmADFRendererProps = Omit<ADFRendererProps, 'isPerformanceModeActive'>;

export const InheritedExtensionRenderer = (props: NestedLcmADFRendererProps): React.JSX.Element => {
	const dataProviders = useNestedLcmProviderFactory();

	return <ADFRenderer {...props} dataProviders={dataProviders} />;
};

/** Keep manifests reachable through macros that introduce another ADF renderer inside an LCM. */
export const NestedLcmADFRenderer = (props: NestedLcmADFRendererProps): React.JSX.Element => {
	const isNestedLcmHierarchy = useContext(NestedLcmHierarchyContext);

	return isNestedLcmHierarchy ? (
		<InheritedExtensionRenderer {...props} />
	) : (
		<ADFRenderer {...props} />
	);
};
